import React from "react";

function FilterBlock({
  mergedArray,
  setArrToShow,
  setFadein,
  setIsactiveBtn,
  isActiveBtn
}) {
  
  const onclickFilter = (btnName) => {
    setFadein(1);
    switch (btnName) {
      case "err":
        setArrToShow(mergedArray.filter((item) => item.isError === true));
        setIsactiveBtn("err");
        break;
      case "all":
        setArrToShow(mergedArray);
        setIsactiveBtn("all");
        break;
      case "right":
        setArrToShow(mergedArray.filter((item) => item.isError === false));
        setIsactiveBtn("right");
        break;
      default:
        break;
    }
  };
  return (
    <div className="content-block result-answers">
      <h2 className="center-text">Ваши ответы</h2>
      <div className="result-answers-button-section">
        <div
          className={
            "button btn-filter " + (isActiveBtn === "err" ? " active-ticket-item" : "")
          }
          onClick={() => {
            onclickFilter("err");
          }}
        >
          Только ошибки
        </div>
        <div
          className={
            "button btn-filter " + (isActiveBtn === "all" ? " active-ticket-item" : "")
          }
          onClick={() => {
            onclickFilter("all");
          }}
        >
          Все ответы
        </div>
        <div
          className={
            "button btn-filter " + (isActiveBtn === "right" ? " active-ticket-item" : "")
          }
          onClick={() => {
            onclickFilter("right");
          }}
        >
          Только верные
        </div>
      </div>
    </div>
  );
}

export default FilterBlock;
